<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconEdit_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M18.062 3c-.78 0-1.527.31-2.078.86L4.217 15.629a.94.94 0 0 0-.248.437l-.94 3.765a.94.94 0 0 0 1.14 1.142l3.766-.942a.94.94 0 0 0 .437-.247L20.14 8.016A2.938 2.938 0 0 0 18.062 3"
        clip-rule="evenodd"
    />
</svg>
